export default __webpack_public_path__ + "static/media/searchIcon.f7d9a231.svg";